import { AxiosInstance } from "axios";
import { ApiRoutes } from "../../../root/apiRoutes";
import { MarketingWebsiteContentList } from "../dto/MarketingWebsiteContentDto";

export class MarketingWebsiteContentController {
  constructor(private axios: AxiosInstance) {}

  public getLatestContent = async (): Promise<MarketingWebsiteContentList> => {
    const url = ApiRoutes.marketingWebsiteContent.root;
    const response = await this.axios.get<MarketingWebsiteContentList>(url);
    return response.data;
  };
}
